import Trans from '@/components/shared/Trans';
import translations from '../FilterBar.trans.json';
import { buildRangeDateOptions } from '../constants/rangeDateOptions';
import RangeDateDropdownView from './RangeDateDropdownView';

function RangeDateDropdownControlled({
  value,
  onChange,
  title,
  buttonText,
  dataTestId,
  className,
  buttonClassName,
  filled = false,
  selection,
}) {
  const rangeDateTitle =
    title || Trans(translations, 'filterBarLeads.CreationDate');
  const rangeDateOptions = buildRangeDateOptions((key) =>
    Trans(translations, key)
  );

  return (
    <RangeDateDropdownView
      rangeDateOptions={rangeDateOptions}
      currentSelection={value}
      valueTextButton={buttonText || value?.text || rangeDateTitle}
      filled={filled}
      dataTestId={dataTestId}
      className={className}
      buttonClassName={buttonClassName}
      selection={selection}
      onSelectPreset={(option) =>
        onChange({
          id: option.id,
          text: option.text,
          value: option.value,
          type: 'date',
        })
      }
      onApplyCustom={(next) => onChange(next)}
    />
  );
}

export default RangeDateDropdownControlled;
